module.exports = __webpack_public_path__ + "static/media/img-logo-PDBAD.6632edf6.png";